export type HttpErrorCategory =
	| 'bad_request_400'
	| 'unauthorized_401'
	| 'forbidden_403'
	| 'rate_limited_429'
	| 'other_4xx'
	| 'other_5xx'
	| 'other_http'
	| 'non_http'
	| 'unknown';

export const toHttpErrorCategory = (status?: number | null): HttpErrorCategory => {
	if (status === undefined || status === null || status === 0) {
		return 'non_http';
	}

	if (!Number.isInteger(status) || status < 100 || status > 599) {
		return 'unknown';
	}

	if (status === 400) {
		return 'bad_request_400';
	}

	if (status === 401) {
		return 'unauthorized_401';
	}

	if (status === 403) {
		return 'forbidden_403';
	}

	if (status === 429) {
		return 'rate_limited_429';
	}

	if (status >= 400 && status <= 499) {
		return 'other_4xx';
	}

	if (status >= 500 && status <= 599) {
		return 'other_5xx';
	}

	// Valid HTTP statuses outside 4xx/5xx are retained as a separate category.
	return 'other_http';
};
